import React from "react";
import PropTypes from "prop-types";
import { imgSrc } from "../../../modules";
import { Image } from "antd";
import "./team.css";

// const galleries = [[], [], ["1.jpg", "2.jpg", "3.jpg", "4.jpg", "5.jpg", "6.jpg", "7.jpg"]];

class TeamComponent extends React.Component {
    render() {
        const { teams } = this.props;
        if (!teams || typeof teams != 'object') {
            return <div id="team"></div>;
        }
        return (
            <div id="team">
                <div className="container">
                    <h2>ทีมงานของเรา</h2>
                    <p>ด้วยบุคลากรด้านโลจิสติกส์กว่า 200 คน ที่พร้อมด้วยทักษะ ประสบการณ์ และความชำนาญ ประจำตามสาขาต่างๆทุกภูมิภาค มีความพร้อมในการตอบสนองความต้องการของลูกค้าได้อย่างดีเยี่ยม</p>
                    <h3>ตรวจสุขภาพ</h3>
                    <h3>ตรวจประวัติอาชญากรรม</h3>
                    <h3>ประชุมประจำปี/ประชุมประจำเดือน</h3>
                    <div className="gallery">
                        <Image.PreviewGroup>
                            {Object.keys(teams[2]).map((key) => {
                                return (
                                    <div key={"gallery_" + key}>
                                        <Image
                                            key={"team3_" + key}
                                            src={imgSrc(teams[2][key].image, false, "team/3/thumbnail")}
                                            alt={teams[2][key].name}
                                            preview={{
                                                src: imgSrc(teams[2][key].image, false, "team/3"),
                                            }}
                                        />
                                        <p className="caption">{teams[2][key].name}</p>
                                    </div>
                                );
                            })}
                        </Image.PreviewGroup>
                    </div>
                </div>
            </div>
        );
    }
}
TeamComponent.propTypes = {
    teams: PropTypes.array.isRequired,
};
export default TeamComponent;
